<script setup>
import { ButtonTypes } from '@@/components/Common/Button.vue';

defineEmits(['show-add-favorites-dialog']);
</script>

<template>
  <footer class="tw-mt-2 lg:tw-mt-5 tw-mb-1 lg:tw-mb-2 tw-text-center">
    <Button
      additional-class-names="tw-w-full md:tw-w-auto"
      :type="ButtonTypes.primary"
      @click="$emit('show-add-favorites-dialog')"
    >
      Add Favorite Location
    </Button>
  </footer>
</template>
